export default __webpack_public_path__ + "static/media/laconic_mobile.722d1d3d.jpg";